// Official Yext-branded colors used throughout Storm and elsewhere.
// Generated file, do not edit

const computedStyles = window.getComputedStyle(document.documentElement);

/**
 * @param {string} propertyName
 * @param {string} fallbackHex
 * @returns {string}
 */
function getProperty(propertyName, fallbackHex) {
  return computedStyles.getPropertyValue(propertyName) || fallbackHex;
}

/** @type {string} */
export const YEXT_BRAND_COLOR = getProperty('--yext-brand-color', '#14bef0');

/** @type {string} */
export const YEXT_RED = getProperty('--yext-red', '#ba031c');

/** @type {string} */
export const YEXT_RED_LIGHT = getProperty('--yext-red-light', '#d66877');

/** @type {string} */
export const YEXT_RED2 = getProperty('--yext-red2', '#e60a2d');

/** @type {string} */
export const YEXT_RED3 = getProperty('--yext-red3', '#910008');

/** @type {string} */
export const YEXT_STRAWBERRY = getProperty('--yext-strawberry', '#f2326b');

/** @type {string} */
export const YEXT_STRAWBERRY_LIGHT = getProperty('--yext-strawberry-light', '#f784a6');

/** @type {string} */
export const YEXT_ORANGE = getProperty('--yext-orange', '#dc671f');

/** @type {string} */
export const YEXT_ORANGE_LIGHT = getProperty('--yext-orange-light', '#eaa479');

/** @type {string} */
export const YEXT_ORANGE2 = getProperty('--yext-orange2', '#fb9209');

/** @type {string} */
export const YEXT_ORANGE3 = getProperty('--yext-orange3', '#f67323');

/** @type {string} */
export const YEXT_YELLOW = getProperty('--yext-yellow', '#fdc131');

/** @type {string} */
export const YEXT_YELLOW_LIGHT = getProperty('--yext-yellow-light', '#fdcd8a');

/** @type {string} */
export const YEXT_GREEN = getProperty('--yext-green', '#239f25');

/** @type {string} */
export const YEXT_GREEN2 = getProperty('--yext-green2', '#176827');

/** @type {string} */
export const YEXT_GREEN_LIGHT = getProperty('--yext-green-light', '#7bc57c');

/** @type {string} */
export const YEXT_GREEN2_LIGHT = getProperty('--yext-green2-light', '#74a47d');

/** @type {string} */
export const YEXT_GREEN3 = getProperty('--yext-green3', '#05ad83');

/** @type {string} */
export const YEXT_GREEN4 = getProperty('--yext-green4', '#90b02b');

/** @type {string} */
export const YEXT_GREEN5 = getProperty('--yext-green5', '#05ad8e');

/** @type {string} */
export const YEXT_MINT = getProperty('--yext-mint', '#23d2be');

/** @type {string} */
export const YEXT_MINT_LIGHT = getProperty('--yext-mint-light', '#7be4d8');

/** @type {string} */
export const YEXT_BLUE = getProperty('--yext-blue', '#178acd');

/** @type {string} */
export const YEXT_BLUE_LIGHT = getProperty('--yext-blue-light', '#74b9e1');

/** @type {string} */
export const YEXT_BLUE2 = getProperty('--yext-blue2', '#024ba5');

/** @type {string} */
export const YEXT_BLUE2_LIGHT = getProperty('--yext-blue2-light', '#6793c9');

/** @type {string} */
export const YEXT_NAVY = getProperty('--yext-navy', '#161d56');

/** @type {string} */
export const YEXT_NAVY_LIGHT = getProperty('--yext-navy-light', '#73779a');

/** @type {string} */
export const YEXT_PURPLE = getProperty('--yext-purple', '#842660');

/** @type {string} */
export const YEXT_PURPLE_LIGHT = getProperty('--yext-purple-light', '#b57da0');

/** @type {string} */
export const YEXT_TURQUOISE = getProperty('--yext-turquoise', '#1F7E98');

/** @type {string} */
export const YEXT_SAFFRON_LIGHT = getProperty('--yext-saffron-light', '#FFF8E6');

/** @type {string} */
export const YEXT_SAFFRON_DARK = getProperty('--yext-saffron-dark', '#7E5B06');

/** @type {string} */
export const BRAND_BLUE = getProperty('--brand-blue', '#14bef0');

/** @type {string} */
export const BRAND_BLUE_WCAG = getProperty('--brand-blue-wcag', '#1564F9');

/** @type {string} */
export const BRAND_RED = getProperty('--brand-red', '#ef4e22');

/** @type {string} */
export const BRAND_GREEN = getProperty('--brand-green', '#64bd5f');

/** @type {string} */
export const BRAND_PURPLE = getProperty('--brand-purple', '#a877b4');

/** @type {string} */
export const BRAND_YELLOW = getProperty('--brand-yellow', '#f9d100');

/** @type {string} */
export const WHITE = getProperty('--white', '#ffffff');

/** @type {string} */
export const GRAY1 = getProperty('--gray1', '#f9fafb');

/** @type {string} */
export const GRAY2 = getProperty('--gray2', '#f0f2f4');

/** @type {string} */
export const GRAY3 = getProperty('--gray3', '#e1e5e8');

/** @type {string} */
export const GRAY4 = getProperty('--gray4', '#c4cbd0');

/** @type {string} */
export const GRAY5 = getProperty('--gray5', '#8896a1');

/** @type {string} */
export const GRAY6 = getProperty('--gray6', '#6b7c8a');

/** @type {string} */
export const GRAY7 = getProperty('--gray7', '#4d6272');

/** @type {string} */
export const GRAY8 = getProperty('--gray8', '#3a4856');

/** @type {string} */
export const GRAY9 = getProperty('--gray9', '#313a47');

/** @type {string} */
export const BLACK = getProperty('--black', '#000000');

/** @type {string} */
export const CONCRETE_100 = getProperty('--concrete-100', '#f7f7f8');

/** @type {string} */
export const CONCRETE_200 = getProperty('--concrete-200', '#eeeff0');

/** @type {string} */
export const CONCRETE_300 = getProperty('--concrete-300', '#c5cace');

/** @type {string} */
export const CONCRETE_400 = getProperty('--concrete-400', '#8996a0');

/** @type {string} */
export const CONCRETE_500 = getProperty('--concrete-500', '#5b646b');

/** @type {string} */
export const CONCRETE_525 = getProperty('--concrete-525', '#4e555b');

/** @type {string} */
export const CONCRETE_550 = getProperty('--concrete-550', '#3f4448');

/** @type {string} */
export const CONCRETE_600 = getProperty('--concrete-600', '#2e3235');

/** @type {string} */
export const CONCRETE_625 = getProperty('--concrete-625', '#262626');

/** @type {string} */
export const CONCRETE_650 = getProperty('--concrete-650', '#161616');

/** @type {string} */
export const GRAY100 = getProperty('--gray100', '#F9FAFB');

/** @type {string} */
export const GRAY200 = getProperty('--gray200', '#F0F2F4');

/** @type {string} */
export const GRAY300 = getProperty('--gray300', '#E1E5E8');

/** @type {string} */
export const GRAY400 = getProperty('--gray400', '#C4CBD0');

/** @type {string} */
export const GRAY450 = getProperty('--gray450', '#7F8898');

/** @type {string} */
export const GRAY500 = getProperty('--gray500', '#686F7D');

/** @type {string} */
export const GRAY600 = getProperty('--gray600', '#4B5563');

/** @type {string} */
export const GRAY700 = getProperty('--gray700', '#374151');

/** @type {string} */
export const GRAY800 = getProperty('--gray800', '#2A3443');

/** @type {string} */
export const GRAY900 = getProperty('--gray900', '#111827');

/** @type {string} */
export const RED200 = getProperty('--red200', '#FFF5F4');

/** @type {string} */
export const RED400 = getProperty('--red400', '#F1BCB8');

/** @type {string} */
export const RED700 = getProperty('--red700', '#BA031C');

/** @type {string} */
export const RED800 = getProperty('--red800', '#910008');

/** @type {string} */
export const GREEN200 = getProperty('--green200', '#E9F5E9');

/** @type {string} */
export const GREEN700 = getProperty('--green700', '#176827');

/** @type {string} */
export const ORANGE200 = getProperty('--orange200', '#FEF1E9');

/** @type {string} */
export const ORANGE700 = getProperty('--orange700', '#C44204');

/** @type {string} */
export const YELLOW200 = getProperty('--yellow200', '#FFF8E6');

/** @type {string} */
export const YELLOW500 = getProperty('--yellow500', '#FDC131');

/** @type {string} */
export const YELLOW800 = getProperty('--yellow800', '#7E5B06');
